import { StateSchema } from 'app/config/storeConfig/types';

export const getSnapStepPixels = (state: StateSchema): number => state.warehouseMapConstructor.snapStepPixels;
